<template>
    <OptionAbstract 
        class="option-icon" 
        :class="{
            'compact': compact,
            'strong': strong, 
            'not-strong': !strong
        }"
        :compact="compact">
        <div class="icon">
            <v-icon :icon="icon" />
        </div>

        <div class="label">
            {{ label }}
        </div>

        <div class="description">
            {{ description }}
        </div>
    </OptionAbstract>
</template>

<script>
import OptionAbstract from '@/components/flow/options/OptionAbstract.vue'

export default {
    name: 'OptionIcon',
    components: {
        OptionAbstract
    },
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        strong: {
            type: Boolean,
            default: true
        },
        compact: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.option-icon {
    color: rgb(var(--v-theme-primary));
}

.option-icon .v-icon {
    width: 6.5rem;
    margin-bottom: 1rem;
    font-size: 6.5rem;
    background: linear-gradient(
        180deg, 
        rgb(var(--v-theme-color1)) 0%, 
        rgb(var(--v-theme-color2)) 100%
    );
    /*
    background: linear-gradient(
        135deg, 
        rgb(var(--v-theme-color1)) 0%, 
        rgb(var(--v-theme-color2)) 50%,
        rgb(var(--v-theme-color3)) 100%
    );
    */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.option-icon .label {
    font-size: 3rem;
    text-transform: capitalize;
}

.option-icon.strong .label {
    font-weight: bold;
}

.option-icon .description {
    font-size: 2.5rem;
    color: rgb(var(--v-theme-tertiary));
}

@media (max-width: 3000px) {
    .option-icon .v-icon {
        font-size: 5.5rem;
    }

    .option-icon .label {
        font-size: 2.3rem;
    }

    .option-icon .description {
        font-size: 1.8rem;
    }
}

@media (max-width: 2000px) {
    .option-icon .v-icon  {
        font-size: 5rem;
    }

    .option-icon .label {
        font-size: 2.0rem;
    }

    .option-icon .description {
        font-size: 1.5rem;
    }
}

@media (max-width: 1600px) {
    .option-icon .v-icon  {
        font-size: 4.5rem;
    }

    .option-icon .label {
        font-size: 1.7rem;
    }

    .option-icon .description {
        font-size: 1.2rem;
    }
}

@media (max-width: 1200px) {
    .option-icon .v-icon  {
        font-size: 4rem;
        margin-bottom: 15px;
    }

    .option-icon .label {
        font-size: 1.6rem;
    }

    .option-icon .description {
        font-size: 1.1rem;
    }
}

@media (max-width: 800px) {
    .option-icon .v-icon  {
        font-size: 3.5rem;
        margin-bottom: 15px;
    }

    .option-icon .label {
        font-size: 1.5rem;
    }

    .option-icon .description {
        font-size: 1.0rem;
    }
}

@media (max-width: 600px) {
    .option-icon .v-icon  {
        font-size: 3rem;
        margin-bottom: 10px;
    }

    .option-icon .label {
        font-size: 1.4rem;
    }

    .option-icon .description {
        font-size: 0.9rem;
    }
}

.option-icon.compact .v-icon {
    width: 4.55rem;
    margin-bottom: 0.7rem;
    font-size: 4.55rem;
}

.option-icon.compact .label {
    font-size: 2.1rem;
    line-height: 1.2;
}

.option-icon.compact .description {
    font-size: 1.75rem;
    line-height: 1.2;
}

@media (max-width: 3000px) {
    .option-icon.compact .v-icon {
        width: 3.85rem;
        font-size: 3.85rem;
    }

    .option-icon.compact .label {
        font-size: 1.61rem;
    }

    .option-icon.compact .description {
        font-size: 1.26rem;
    }
}

@media (max-width: 2000px) {
    .option-icon.compact .v-icon {
        width: 3.5rem;
        font-size: 3.5rem;
    }

    .option-icon.compact .label {
        font-size: 1.4rem;
    }

    .option-icon.compact .description {
        font-size: 1.05rem;
    }
}

@media (max-width: 1600px) {
    .option-icon.compact .v-icon {
        width: 3.15rem;
        font-size: 3.15rem;
    }

    .option-icon.compact .label {
        font-size: 1.19rem;
    }

    .option-icon.compact .description {
        font-size: 0.84rem;
    }
}

@media (max-width: 1200px) {
    .option-icon.compact .v-icon {
        width: 2.8rem;
        margin-bottom: 0.5rem;
        font-size: 2.8rem;
    }

    .option-icon.compact .label {
        font-size: 1.12rem;
    }

    .option-icon.compact .description {
        font-size: 0.77rem;
    }
}

@media (max-width: 800px) {
    .option-icon.compact .v-icon {
        width: 2.45rem;
        font-size: 2.45rem;
    }

    .option-icon.compact .label {
        font-size: 1.05rem;
    }

    .option-icon.compact .description {
        font-size: 0.7rem;
    }
}

@media (max-width: 600px) {
    .option-icon.compact .v-icon {
        width: 2.1rem;
        font-size: 2.1rem;
    }

    .option-icon.compact .label {
        font-size: 0.98rem;
    }

    .option-icon.compact .description {
        font-size: 0.63rem;
    }
}
</style>
